{
  "es": {
    "lead": {
      "actions": {
        "add_company": "Añadir organización",
        "add_lead": "Añadir interesado",
        "new": "Interesado"
      },
      "attributes": {
        "address": "Dirección",
        "birth_date": "Fecha de nacimiento",
        "categories": {
          "enduser": "Comprador ocupante",
          "investor": "Inversor"
        },
        "category": "Tipo de interesado",
        "company_name": "Nombre de la organización",
        "company_vat": "Número de IVA",
        "email_address": "Correo electrónico",
        "first_name": "Nombre",
        "iban": "IBAN",
        "internal_note": "Nota interna",
        "language": "Idioma",
        "last_name": "Apellidos",
        "phone_landline": "Número de teléfono fijo",
        "phone_mobile": "Número de móvil",
        "status": "Estado"
      },
      "labels": {
        "detailed_information": "Introduce la información detallada",
        "lead": "Interesado"
      },
      "validation": {
        "needFirstName": "El nombre es obligatorio",
        "needLastName": "Los apellidos son obligatorios"
      }
    }
  }
}
